import { useTranslator } from '@front-activerse/common-components';

const DayPlanIngredientList = ({
  renderIngredients,
  renderOnlySeasoningsIngredients,
  renderOptionalIngredients,
  portions,
}) => {
  const { t } = useTranslator();

  const renderOnlySeasoningsFromIngredients = () => {
    const items = renderOnlySeasoningsIngredients();

    if (items.length <= 0) {
      return null;
    }
    return (
      <>
        <p className="semi-bold mt-l">{t('mealDetails.ingredientList.seasoningsTitle')}</p>
        <ul className="ingredients" data-test="seasonings-ingredients">
          {items}
        </ul>
      </>
    );
  };

  const renderOptionalIngredientsFromIngredients = () => {
    const items = renderOptionalIngredients();

    if (items.length <= 0) {
      return null;
    }
    return (
      <>
        <p className="semi-bold">{t('mealDetails.ingredientList.additionalIngredientsTitle')}</p>
        <ul className="ingredients">{items}</ul>
      </>
    );
  };

  return (
    <>
      {portions ? (
        <p className="semi-bold">{t('ingredients.ForXPortion', { count: portions })}</p>
      ) : (
        <p className="semi-bold">{t('mealDetails.ingredientList.ingredientsTitle')}</p>
      )}
      <ul className="ingredients">{renderIngredients()}</ul>
      {renderOnlySeasoningsFromIngredients()}
      {renderOptionalIngredientsFromIngredients()}
    </>
  );
};

export default DayPlanIngredientList;
